import { Component } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { ThemeService } from './core/services/theme.service';
import { ResponsiveHelperComponent } from './shared/components/responsive-helper/responsive-helper.component';

import FHIR, { client } from "fhirclient";
import { error } from 'console';
import { AppService } from './app.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, ResponsiveHelperComponent, NgxSonnerToaster],
})
export class AppComponent {
  title = 'Smart Apps';

  private intervalId: any;
  constructor(public themeService: ThemeService, private activatedRoute: ActivatedRoute, private appService: AppService) {

    this.appService.login();

  }

  ngOnInit(): void {


    FHIR.oauth2.ready().then((client) => {
      let url = "Patient/" + client.patient.id;
      client.request(url)
        .then((patient) => {
          if (patient.name != null) {
            sessionStorage.setItem("username", patient.name[0].text);
            this.appService.changeMessage(patient);
          }
        }).catch((response) => {
          if (response.status == 401) {
            sessionStorage.removeItem("authenticated");
            this.appService.login();
          }
        });
    }).then(x => {
    }).catch((response) => {
      if (response.status == 401) {
        sessionStorage.removeItem("authenticated");
        this.appService.login();
      }
    });
    // Call the function every 2 seconds
    this.intervalId = setInterval(() => {
      FHIR.oauth2.ready().then((client) => {
        client.refresh();
        this.newToken();
      }).catch((error) => {
        console.error("Error Request", error);
        clearInterval(this.intervalId);
      });
    }, 20000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  newToken() {
    var SMART_KEY = sessionStorage.getItem("SMART_KEY");
    if (SMART_KEY != null) {
      var SMART_DATA = sessionStorage.getItem(SMART_KEY.replace(/"/g, ""));
      if (SMART_DATA != null) {
        var SMART_JSON = JSON.parse(SMART_DATA);
        sessionStorage.setItem("SMART_TOKEN", JSON.stringify(SMART_JSON.tokenResponse));
      }
    }
  }

}
